import { createSelector } from "@ngrx/store";
import { AppState } from "../../app.state";

export const selectComentariosState = ( state: AppState ) => state.comentarios;
export const selectComentarios = createSelector(selectComentariosState, (state) => state);